export default {
  tokens: null,
  player: null,
  language: 'en',
  sessionId: null,
  isConnectedToSession: false,
}
